import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  validateShopifyUrl,
  clearValidateShopifyUrl,
} from 'redux/integrations/actions';

import { Form } from 'semantic-ui-react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import TextField
  from 'components/redux-form-adapters/TextField';

import Button from 'components/elements/buttons/Button';
import CommonMessage from 'components/common/CommonMessage';

import { SITE_URL } from 'utils/restapi';

import validate from './validate';
import { fixURL } from 'utils/fixURL';

import './ShopifyConnectStoreForm.css';

class ShopifyConnectStoreForm extends Component {
  static propTypes = {
    validateShopifyUrl: PropTypes.func.isRequired,
    clearValidateShopifyUrl: PropTypes.func.isRequired,
    validateShopifyUrlSuccess: PropTypes.object,
    validateShopifyUrlError: PropTypes.object,
    storeUrl: PropTypes.string
  };

  static defaultProps = {
    validateShopifyUrlSuccess: null,
    validateShopifyUrlError: null,
    storeUrl: null,
  };

  state = {
    urlValidation: false,
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.validateShopifyUrlSuccess && this.props.validateShopifyUrlSuccess) {
      this._connectShopify();
    }

    if (
      (!prevProps.validateShopifyUrlSuccess && this.props.validateShopifyUrlSuccess) ||
      (!prevProps.validateShopifyUrlError && this.props.validateShopifyUrlError)
    ) {
      this.setState({ urlValidation: false });
    }
  }

  componentWillUnmount() {
    this.props.clearValidateShopifyUrl();
  }

  _handleSubmit = values => {
    this._validateShopifyUrl(values);
  };

  _validateShopifyUrl = values => {
    this.props.clearValidateShopifyUrl();
    this.setState({ urlValidation: true });
    const urlValue = fixURL(values.storeUrl);
    this.props.validateShopifyUrl(urlValue);
  };

  _connectShopify = () => {
    const domain = this.props.validateShopifyUrlSuccess &&
      this.props.validateShopifyUrlSuccess.domain;
    const SHOPIFY_API_KEY = '5df211fdccca6624ca9decc2bd94361f';
    const SHOPIFY_SCOPE = 'read_products,read_product_listings';
    const CALLBACK_URL = `${SITE_URL}/integrations/shopify/connect/`;
    const shopifyAuthURL = [
      `https://${domain}/admin/oauth/authorize`,
      `?client_id=${SHOPIFY_API_KEY}`,
      `&scope=${SHOPIFY_SCOPE}`,
      `&redirect_uri=${CALLBACK_URL}`,
    ].join('');
    if (domain) {
      window.location.href = shopifyAuthURL;
    }
  };

  render() {
    return (
      <div className="shopify-connect-store-form__component">

        <div className="header">Setup Instructions</div>
        <ol>
          <li>Enter your Shopify store URL and click “Connect Shopify” button</li>
          <li>Please review the permissions and install HeyLink.me app</li>
          <li>Please wait 20-30 seconds for your Shopify products to be imported</li>
          <li>Success! You can view your Shopify products under “STORE” tab and share your HeyLink.me link with your Shopify products anywhere!</li>
        </ol>

        <div className="header">
          Connect your Shopify Store
        </div>

        <Form
          onSubmit={this.props.handleSubmit(this._handleSubmit)}
          error={!this.props.valid}
        >
          <Field
            component={TextField}
            name="storeUrl"
            type="text"
            placeholder="Your Shopify store URL"
            required
          />
          <Button
            submit
            loading={this.state.urlValidation}
            disabled={!this.props.valid || !this.props.storeUrl}
          >
            Connect Shopify
          </Button>
        </Form>

        {this.props.validateShopifyUrlError &&
          <CommonMessage error>
            Shopify validation error. Please verify your Shopify store url.
          </CommonMessage>
        }

        {/*<div className="shopify-tutorial-link">*/}
        {/*  <a*/}
        {/*    href="http://www.blog.persollo.com/single-post/2018/02/27/Product-Update-Shopify-Plugin-Released"*/}
        {/*    target="_blank"*/}
        {/*    rel="noopener noreferrer"*/}
        {/*  >*/}
        {/*    How to connect your Shopify Store with HeyLink.me?*/}
        {/*  </a>*/}
        {/*</div>*/}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const selector = formValueSelector('ShopifyConnectStoreForm');
  return {
    storeUrl: selector(state, 'storeUrl'),
    validateShopifyUrlSuccess: state.integrationsReducer.validateShopifyUrlSuccess,
    validateShopifyUrlError: state.integrationsReducer.validateShopifyUrlError,
  };
};

export default connect(
  mapStateToProps,
  {
    validateShopifyUrl,
    clearValidateShopifyUrl,
  },
)(reduxForm({
  form: 'ShopifyConnectStoreForm',
  validate,
})(ShopifyConnectStoreForm));
